(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("prop-types"), require("react"), require("underscore"), require("classnames"), require("@bingads-webui-react/i18n-context"), require("@bingads-webui-react/with-default-styles"));
	else if(typeof define === 'function' && define.amd)
		define(["prop-types", "react", "underscore", "classnames", "@bingads-webui-react/i18n-context", "@bingads-webui-react/with-default-styles"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("prop-types"), require("react"), require("underscore"), require("classnames"), require("@bingads-webui-react/i18n-context"), require("@bingads-webui-react/with-default-styles")) : factory(root["prop-types"], root["react"], root["underscore"], root["classnames"], root["@bingads-webui-react/i18n-context"], root["@bingads-webui-react/with-default-styles"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__6__, __WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__8__, __WEBPACK_EXTERNAL_MODULE__9__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "HelpPopup", {
  enumerable: true,
  get: function get() {
    return _helpPopup.HelpPopup;
  }
});
Object.defineProperty(exports, "HelpPopupInline", {
  enumerable: true,
  get: function get() {
    return _helpPopupInline.HelpPopupInline;
  }
});
Object.defineProperty(exports, "HelpButton", {
  enumerable: true,
  get: function get() {
    return _helpButton.HelpButton;
  }
});

var _helpPopup = __webpack_require__(2);

var _helpPopupInline = __webpack_require__(5);

var _helpButton = __webpack_require__(10);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpPopup = HelpPopup;

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid, no-script-url */

/* global PopupController */
// NOTE: preferably use HelpButton to avoid accessibility issues

/**
 * @param {MouseEvent} event click event
 * @return {void}
 */
function onClick(event) {
  event.preventDefault();
  event.stopPropagation();

  if (!window.PopupController) {
    return;
  }

  PopupController.PopupJsClick(event.target);
}

function HelpPopup(props) {
  return _react.default.createElement("a", {
    "aria-label": props['aria-label'],
    "aria-labelledby": props['aria-labelledby'],
    className: "helpbutton",
    href: "#",
    onClick: onClick,
    topic: props.topic,
    type: "helppopup",
    role: "button"
  });
}

HelpPopup.propTypes = {
  'aria-label': _propTypes.default.string,
  'aria-labelledby': _propTypes.default.string,
  topic: _propTypes.default.string.isRequired
};
HelpPopup.defaultProps = {
  'aria-label': null,
  'aria-labelledby': null
};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpPopupInline = exports.InlineHelpUnstyled = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(6));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(4));

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _i18nContext = __webpack_require__(8);

var _withDefaultStyles = __webpack_require__(9);

var _helpPopup = __webpack_require__(2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// NOTE: preferably use HelpButton to avoid accessibility issues
const InlineHelpUnstyled = (0, _react.memo)(props => {
  const classes = props.classes,
        topic = props.topic,
        withoutSpace = props.withoutSpace,
        onClick = props.onClick,
        ariaLabel = props.ariaLabel;
  const i18n = (0, _react.useContext)(_i18nContext.I18nContext);
  return _react.default.createElement("span", {
    className: (0, _classnames.default)({
      [classes.inlineHelp]: true,
      [classes.withSpace]: !withoutSpace
    }),
    role: "presentation",
    onClick: onClick
  }, _react.default.createElement(_helpPopup.HelpPopup, {
    "aria-label": ariaLabel || i18n.getString(_TL_('Learn more')),
    topic: topic
  }));
});
exports.InlineHelpUnstyled = InlineHelpUnstyled;
InlineHelpUnstyled.propTypes = {
  topic: _propTypes.default.string.isRequired,
  classes: _propTypes.default.shape({
    inlineHelp: _propTypes.default.string
  }).isRequired,
  withoutSpace: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  ariaLabel: _propTypes.default.string
};
InlineHelpUnstyled.defaultProps = {
  withoutSpace: false,
  onClick: _underscore.default.noop,
  ariaLabel: null
};
const HelpPopupInline = (0, _withDefaultStyles.withDefaultStyles)(InlineHelpUnstyled, (components, {
  palette = {},
  iconFontFamily = 'MsAds MDL2 Assets'
}) => ({
  inlineHelp: {
    display: 'inline-block',
    fontSize: '15px !important',
    fontWeight: 'normal',
    '& .helpbutton': {
      paddingTop: '2px',
      paddingLeft: '2px',
      '&::before': {
        content: '"\\E9CE"',
        fontFamily: iconFontFamily,
        position: 'relative',
        top: 2
      },
      '&:focus': {
        outline: '1px solid',
        outlineColor: palette.neutralSecondary,
        border: 'none',
        color: palette.black,
        textDecoration: 'none'
      },
      '&:hover': {
        backgroundColor: palette.neutralLighter,
        color: palette.black,
        textDecoration: 'none'
      },
      '&:active': {
        backgroundColor: palette.neutralLight,
        color: palette.black,
        textDecoration: 'none'
      }
    }
  },
  withSpace: {
    marginLeft: 3
  }
}));
exports.HelpPopupInline = HelpPopupInline;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__6__;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__9__;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpButtonUnstyled = HelpButtonUnstyled;
exports.HelpButton = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireWildcard(__webpack_require__(4));

var _i18nContext = __webpack_require__(8);

var _classnames = _interopRequireDefault(__webpack_require__(7));

var _withDefaultStyles = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global PopupController */
function onClick(event) {
  event.preventDefault();
  PopupController.PopupJsClick(event.target);
}

function HelpButtonUnstyled(props) {
  const i18n = (0, _react.useContext)(_i18nContext.I18nContext);
  return _react.default.createElement("button", {
    "aria-label": props['aria-label'] || i18n.getString(_TL_('Learn more')),
    "aria-labelledby": props['aria-labelledby'],
    className: (0, _classnames.default)('helpbutton', props.classes.helpButton),
    onClick: onClick,
    topic: props.topic,
    type: "helppopup"
  });
}

HelpButtonUnstyled.propTypes = {
  'aria-label': _propTypes.default.string,
  'aria-labelledby': _propTypes.default.string,
  topic: _propTypes.default.string.isRequired,
  classes: _propTypes.default.shape({
    helpButton: _propTypes.default.string
  }).isRequired
};
HelpButtonUnstyled.defaultProps = {
  'aria-label': null,
  'aria-labelledby': null
};
const HelpButton = (0, _withDefaultStyles.withDefaultStyles)(HelpButtonUnstyled, (components, {
  palette = {},
  iconFontFamily = 'MsAds MDL2 Assets'
}) => ({
  helpButton: {
    border: '0px',
    fontSize: '15px',
    backgroundColor: 'inherit !important',
    textDecoration: 'none !important',
    cursor: 'pointer',
    '&:focus': {
      border: `1px solid ${palette.neutralSecondary}`
    },
    color: palette.themePrimary,
    fontWeight: 'normal',
    padding: '0px',
    display: 'block',
    '&:before': {
      top: '2px',
      content: '"\\E9CE"',
      position: 'relative',
      fontFamily: iconFontFamily
    }
  }
}));
exports.HelpButton = HelpButton;

/***/ })
/******/ ]);
});
